module.exports = __webpack_public_path__ + "images/bc619e334b4cd0d979d00f386b7f18b0.png";